import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var chipContent = createRuntimeFn({defaultClassName:'fx_e395032e_16q4jg3',variantClassNames:{size:{'default':'fx_e395032e_16q4jg4',large:'fx_e395032e_16q4jg5'}},defaultVariants:{size:'default'},compoundVariants:[]});
var chipContentHorizontalGap = 'var(--fx_e395032e_16q4jg0)';

export { chipContent, chipContentHorizontalGap };
//# sourceMappingURL=content.vanilla.mjs.map
